export const phoneNumberMask = '["(##) ####-####", "(##) # ####-####"]';
